<template>
  <!-- <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
    
    <div class="container no_space">

        <p class="text-right"><router-link to="/eventos" >VER TODOS <i class="fa fa-chevron-right"></i></router-link></p>
    </div> -->
    <div class="container no_space">
      <h1>{{$t(titulo)}}</h1>
        <div
          v-for="(item, v) in eventos"
          :key="v"
          class="col-lg-6 col-md-6 col-sm-6 col-xs-12"
        >


          <router-link
            :to="`/${$i18n.locale}/detalle/${item.cmsID}/${item.Recinto[0].Id}`"
            class="vacio"
          >

            <div class="img_thumb">


              <v-img
                class="imagen-ficha elevation-5"
                :src="miImagen(item, configuracion.imagen)"
                :aspect-ratio="imagen.ratio"
              >

              </v-img>

            </div>
            <div style="clear: both"></div>

            <div class="det-ficha-home">
              <p><b>{{item.Nombre}} </b><br>
                <i class="fa fa-calendar"></i> {{getFecha(item)}}<br>
                <i class="fa fa-map-marker"></i>
                <i v-if="item.Recinto">{{item.Recinto[0].Nombre}}</i> <i v-if="item.Poblacion"> / {{item.Poblacion[0].Nombre}}</i>
                {{ item.MinPrecioBase }}
                <br>
                <span v-if="item.MinPrecioBase && $i18n.locale == 'eu'" class="pvp">{{ item.MinPrecioBase | formatNumber}} -{{$t('Desde')}}</span>
                <span v-else-if="item.MinPrecioBase" class="pvp">{{$t('Desde')}}: {{ item.MinPrecioBase | formatNumber}}</span>
              </p>
            </div>
          
          <a
           
            class="btn  btn-comprar"
            role="button"
          >
            <i class="fa fa-shopping-cart"></i>&nbsp;{{$t('Comprar')}}</a>
          <a
            
            class="btn  btn-info"
            role="button"
          ><i class="fa fa-info-circle"></i></a>
          <br><br>
          </router-link>
        </div>
    </div>
  <!-- </div> -->
</template>
<style>
#top ul li {
  height: unset !important;
}
.color-fondo {
  background-color: #ffd300;
}
</style>

<script>
import { globales } from "../comunes";

export default {
  mixins: [globales],
  props: ["seccion"],
  computed: {
    seccionActual() {
      const secciones = this.layoutSecciones;
      // console.log("Secciones existes todas", this.layoutSecciones);
      const seccion = this.seccion;
      if (!secciones.hasOwnProperty(seccion)) {
        // console.log("Seccion no existe", seccion);
      }
      return this.layoutSecciones[this.seccion];
    },

    eventos() {
      // console.log("mi seccion actual existes", this.seccionActual);
      const secciones = this.$store.state.layout.secciones;
      const seccionActual = secciones[this.seccion]
        ? secciones[this.seccion]
        : null;
      const visibles = this.configuracion.visibles;
      const items = seccionActual["items"]
        ? seccionActual.items.slice(0, visibles)
        : [];
      const eventosJanto = this.$store.state.eventosJanto;
      const ahora = this.Hoy.ahora;

      const misEventos = items.map(evento => {
        if (eventosJanto[evento]) {
          const item = eventosJanto[evento];

          const id = item.webId;
          const itemWeb = this.$store.state.itemsWeb.find(i => i.id == id);
          console.log("itemWeb", itemWeb, id);
          if (itemWeb) {
            item.cms = itemWeb;
          }

          if (item.FFinVentaMax > ahora && item.FInicioVentaMin < ahora) {
            return item;
          }
        }
      });

      return misEventos.filter(e => e);
    },
    configuracion() {
      return this.seccionActual.configuracion;
    },
    titulo() {
      if (this.configuracion.labelVisible) {
        return this.configuracion.titulo;
      }
    },
    imagen() {
      const src = this.configuracion.imagen;
      const ratio = this.ratios[src];

      return {
        src,
        ratio,
      };
    },
    disposicion() {
      return this.configuracion.columnas;
    },
    // resto() {
    //   const numero = this.configuracion.visibles;
    //   return this.seccionActual.eventos.slice(numero);
    // },
  },
  methods: {
    getItemweb(id) {},
  },
};
</script>
